import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IRanking } from '../interfaces/ranking';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

export const fetchRankingsRequest = () =>
  ({
    type: 'FETCH_RANKINGS_REQUEST'
  } as const);

export const fetchRankingsSuccess = (payload: IRanking[]) =>
  ({
    type: 'FETCH_RANKINGS_SUCCESS',
    payload
  } as const);

export const fetchRankingsFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_RANKINGS_FAILURE',
    error
  } as const;
};

const shouldFetchRankings = (state: CommonRootState) => {
  const {
    rankings: { isFetching, error, rankings }
  } = state;

  return !isFetching && !error && !rankings;
};

export const fetchRankings = (
  organizationId: string,
  contractorId?: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchRankingsRequest());

    const response = await axios.get<IRanking[]>(
      contractorId
        ? `/api/v2/organizations/${organizationId}/contractors/${contractorId}/rankings`
        : `/api/v2/organizations/${organizationId}/rankings`
    );

    dispatch(fetchRankingsSuccess(response.data));
  } catch (error) {
    dispatch(fetchRankingsFailure(error));
  }
};

export const fetchRankingsIfNeeded = (
  organizationId: string,
  contractorId?: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchRankings(getState())) {
    dispatch(fetchRankings(organizationId, contractorId));
  }
};

export type Actions =
  | ReturnType<typeof fetchRankingsRequest>
  | ReturnType<typeof fetchRankingsSuccess>
  | ReturnType<typeof fetchRankingsFailure>;
